import {Component, Input, Output, EventEmitter, OnInit} from "@angular/core";
import { ProposalService } from "src/app/services/proposal-service";
import { MatDialog } from "@angular/material/dialog";
import { ProposalComponent } from "../../proposal/proposal.component";
import { CommentComponent } from "../../comment/comment.component";
import { MsalService } from "@azure/msal-angular";
import { Proposal } from "src/app/entities/proposal";
import { Category } from "src/app/entities/category";
import {Subscription} from "rxjs";
import {StorageMap} from "@ngx-pwa/local-storage";
import {OpenSpaceService} from "../../../services/open-space.service";
import {DatePipe} from "@angular/common";

@Component({
  selector: "app-note",
  templateUrl: "./note.component.html",
  styleUrls: ["./note.component.css"],
})
export class NoteComponent implements OnInit {
  totalComments = 0;
  comments: Comment[];
  openSpaceId: number;
  dataSubscription: Subscription;
  hideButtons: boolean;
  showVotes: boolean;
  showMyVotes: boolean;


  constructor(
    private authService: MsalService,
    private proposalService: ProposalService,
    private openService: OpenSpaceService,
    private storage: StorageMap,
    private datePipe: DatePipe,
    private dialog: MatDialog,
  ) {}

  @Input() proposal: Proposal;
  @Input() categories: Category[];
  @Input() colorOption = 0;
  @Output() proposalNewDataEmiter: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.loadcontent();
    this.canVote();
    this.hideTotalVotes();
  }

  viewProposal() {
    const isProposalOwner =
      this.authService.getAccount().userName === this.proposal.userEmail;
    const dialogRef = this.dialog.open(ProposalComponent, {
      data: {
        proposal: this.proposal,
        categories: this.categories,
        editMode: isProposalOwner,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      const proposalNewData =
        "true" === JSON.stringify(result?.proposalNewData);
      if (proposalNewData) {
        this.proposalNewDataEmiter.emit();
      }
    });
  }

  viewComments() {
    this.totalComments = this.comments?.length;

    const dialogRef = this.dialog.open(CommentComponent, {
      data: { proposalId: this.proposal.id },
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        this.proposal.totalComments = result.data;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  vote() {
    this.proposalService.voteProposal(this.proposal.id).subscribe(
      (data) => {
        if (data) {
          this.proposal.totalVotes = data?.votes;
          this.proposal.userVotes = data?.userVotes;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  unvote() {
    this.proposalService.unvoteProposal(this.proposal.id).subscribe(
      (data) => {
        if (data) {
          this.proposal.totalVotes = data.votes;
          this.proposal.userVotes = data.userVotes;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  canVote() {
    this.hideButtons = false;
    if (this.openSpaceId) {
      this.openService.getOpenSpace(this.openSpaceId).subscribe(data => {
        const votingStartDate = new Date(this.datePipe.transform(data.OpenSpaces[0].allowVotingFromDate, 'MM/dd/yyyy'));
        const votingEndDate = new Date(this.datePipe.transform(data.OpenSpaces[0].allowVotingUntilDate, 'MM/dd/yyyy'));
        const today = new Date(this.datePipe.transform(new Date(), 'MM/dd/yyyy'));
        if (today < votingStartDate || today > votingEndDate) {
          this.hideButtons = true;
        }
      }, error => {
        console.error(error);
      });
    }
  }

  hideTotalVotes() {
    this.showVotes = true;
    this.showMyVotes = true;
    if (this.openSpaceId) {
      this.openService.getOpenSpace(this.openSpaceId).subscribe(
          data => {
            const votingStartDate = new Date(this.datePipe.transform(data.OpenSpaces[0].allowVotingFromDate, 'MM/dd/yyyy'));
            const votingEndDate = new Date(this.datePipe.transform(data.OpenSpaces[0].allowVotingUntilDate, 'MM/dd/yyyy'));
            const today = new Date(this.datePipe.transform(new Date(), 'MM/dd/yyyy'));
            let checkShowTotalVotes = data.OpenSpaces[0].showVotes;
            // Pre inicio votaciones
            if (today < votingStartDate) {
              this.showVotes = false;
              this.showMyVotes = false;
              // Durante Las votaciones
            }else if(today >= votingStartDate && today <= votingEndDate){
              this.showVotes = checkShowTotalVotes
              this.showMyVotes = true;
            }
          },
          error => {
            console.error(error);
          }
      )
    }
  }

  loadcontent() {
    this.dataSubscription = this.storage
        .watch("selectedOpenId", { type: "string" })
        .subscribe((openId) => {
          const openIdInt = parseInt(openId, 10);
          if (!isNaN(openIdInt)) {
            this.openSpaceId = openIdInt;
          }
        });
  }
}

export interface Vote {
  openspace: number;
  proposal: number;
  votes: number;
  userVotes: number;
}

export interface RemainingVotes {
  openspace: number;
  totalVotes: number;
}
